import { render, staticRenderFns } from "./DividerComponent.vue?vue&type=template&id=6c5f2fab&scoped=true"
import script from "./DividerComponent.vue?vue&type=script&lang=js"
export * from "./DividerComponent.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6c5f2fab",
  null
  
)

export default component.exports